module.exports = __webpack_public_path__ + "static/media/o3.7dc34176.png";